import React from 'react';

interface HugeiconsIconProps {
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  className?: string;
  size?: number;
  color?: string;
}

const HugeiconsIcon: React.FC<HugeiconsIconProps> = ({ 
  icon: Icon, 
  className = '', 
  size = 24, 
  color = 'currentColor' 
}) => {
  return (
    <Icon 
      className={className}
      width={size}
      height={size}
      color={color}
    />
  );
};

export default HugeiconsIcon;